// extracted by mini-css-extract-plugin
export default {"first":"#0a4d28","productTextBody":"Pellet_productTextBody__OgUPp","green":"Pellet_green__gz2M1","pelletButtonHref":"Pellet_pelletButtonHref__+16E0"};